import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
	'SAVE_CUSTOM_MESSAGES',
	'GET_CUSTOM_MESSAGES',
);
